<template>
  <b-row>
		<b-col style="margin-left: 10px;margin-right: 10px;">
			<b-row cols="12" style="margin-left: 5px;margin-right: 5px;">
        <b-col sm="12" md="6" lg="6" xl="10">
          <label>Produto</label>
          <basic-select 
            :options="produtoOptions"
            :selectedOption="itemSelecionado"
            placeholder="Pesquisar Produto... "
            @select="onSelect"
            :isDisabled="this.statusPedido == 'F'">
          </basic-select>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="2">
          <label>QTD</label>
          <b-input-group>
            <b-input 
              id="pedido_item_quantidade" 
              v-model="item.QTD"  
              :disabled="this.statusPedido == 'F'" 
              type="number"
              ref="pedido_item_quantidade"/>
            <b-button variant="info" title="Salvar Produto" @click="save"  :disabled="this.statusPedido == 'F'">
              <b-icon icon="check2-circle"></b-icon>
            </b-button>
          </b-input-group>
        </b-col>
			</b-row>
      <PedidoItemTable
        id="pedido_item"
        primaryKey="id"
        :items="itens"
        :fields="fields"
        :onEdit="(this.statusPedido == 'F' ? null : itemDetails)"
        :onDeleteRegister="(this.statusPedido == 'F' ? null : itemDelete)"
        :totalItens="total.itens"
      ></PedidoItemTable>
		</b-col>
	</b-row>  
</template>

<script>
import PedidoItemTable from "@/components/tables/PedidoItemTable";
import PedidoItemServices from "@/services/PedidoItem";
import ProdutoServices from "@/services/Produto";
import utilServices from "@/services/Util";

export default {
  name: "PedidoItens",

  components: {
    PedidoItemTable,
  },

  props: {
    idPedido: {
      type: Number,
      required: true,
    },

    statusPedido: {
      type: String,
      require: true,
    },
  },

  data() {
    return {
      itens: [],

      item: {
        IDCAB: 0,
        PRODUTO: 0,
        QTD: 0,
        STATUS: "N",
      },

      itemSelecionado: {
        value: '',
        text: ''
      },

      produtoOptions: [],

      loading: false,

      fields: [
        {
          key: "PRODUTO",
          sortable: true,
          label: "Código",
        },
        {
          key: "NOME",
          sortable: true,
          label: "Descrição",
        },
        {
          key: "QTD",
          sortable: true,
          label: "Qtd.",
        },
        { key: "actions", label: "Ações", class: "pedido-data-table-acoes" },
      ],

      total: {
        itens: 0
      }
    };
  },

  created: function() {
    this.list();
  },

  methods: {
    list() {      
      PedidoItemServices.list(this.idPedido).then(
        (response) => {
          if (response.data.RET == "1") {
            this.itens = response.data.OBJ;            
          } else if (response.data.OBJ[0].MSG != "Item não localizado!") {
            this.$bvToast.toast(response.data.OBJ[0].MSG, {
              title: "Erro",
              variant: "danger",
              solid: true,
            });            
          } else if (response.data.OBJ[0].MSG == "Item não localizado!") {
            this.itens = [];
          }
          this.getProduto();
          this.totalizaItens();
        },
        (error) => {
          utilServices.parseServerError(error, this);
        }
      );      
    },

    getProduto() {
      ProdutoServices.list().then(
        (response) => {
          // let jsonNormalizado = JSON.parse(
          //   utilServices.normalizaJson(response.data.toString())
          // );
          let jsonNormalizado = response.data;
          if (jsonNormalizado.RET == "1") {
            for (let i = 0; i < jsonNormalizado.OBJ.length; i++) {
              let option;
              option = document.createElement("option");
              option.text = jsonNormalizado.OBJ[i].ID + " - " + jsonNormalizado.OBJ[i].NOME;
              option.value = jsonNormalizado.OBJ[i].ID;
              this.produtoOptions.push(option);
            }
          } else {
            this.$bvToast.toast(response.data.OBJ[0].MSG, {
              title: "Erro",
              variant: "danger",
              solid: true,
            });
          }
        },
        (error) => {
          utilServices.parseServerError(error, this);
        }
      );
    },

    save() {
      var produtoDuplicado = false;
      if (this.item.STATUS == "N") {
        for (let i = 0; i < this.itens.length; i++) {
          if (this.itens[i].PRODUTO == this.item.PRODUTO) {
            produtoDuplicado = true;
            break;
          }
        }
      }
      if (produtoDuplicado) {
        this.$root.$bvToast.toast("Produto já informado.", {
          title: "Aviso",
          variant: "warning",
          solid: true,
        });
      } else if (this.item.PRODUTO == 0) {
        this.$root.$bvToast.toast("Selecione o produto.", {
          title: "Aviso",
          variant: "warning",
          solid: true,
        });
      } else if (this.item.QTD <= 0) {
        this.$root.$bvToast.toast("Informe a quantidade.", {
          title: "Aviso",
          variant: "warning",
          solid: true,
        });
      } else {
        if (this.item.IDCAB == 0) this.item.IDCAB = this.idPedido;
        this.loading = true;
        PedidoItemServices.save(this.item)
          .then((response) => {
            if (response.status === 200) {
              if (response.data.RET == "1") {
                this.$root.$bvToast.toast("Dados salvos com sucesso.", {
                  title: "Sucesso",
                  variant: "success",
                  solid: true,
                });
                this.resetItem();
                this.list();
              } else {
                this.$root.$bvToast.toast(response.data.OBJ[0].MSG, {
                  title: "Erro",
                  variant: "danger",
                  solid: true,
                });
                if (response.data.OBJ[0].MSG == "Item não localizado!")
                  this.itens = [];
              }
            }
          })
          .catch((error) => {
            utilServices.parseServerError(error, this);
          })
          .finally(() => {
            this.loading =  false
          });
      }
      this.totalizaItens();
    },

    resetItem() {
      this.item = {
        IDCAB: 0,
        PRODUTO: 0,
        QTD: 0,
        STATUS: "N",
      };

      this.itemSelecionado = {
        value: '',
        text: ''
      };
    },

    itemDetails(item) {
      this.item = item;
      this.item.STATUS = "E";
      for (let i = 0; i < this.produtoOptions.length; i++) {
        if (this.produtoOptions[i].value == this.item.PRODUTO) {
          this.item.PRODUTO = this.produtoOptions[i].value;
          this.itemSelecionado.value = this.produtoOptions[i].value;
          this.itemSelecionado.text = this.produtoOptions[i].text;
        }
      }
      this.$refs.pedido_item_quantidade.$el.focus();
    },

    itemDelete(item) {
      this.item = item;
      this.item.STATUS = "D";
      this.save();
    },

    totalizaItens() {
      this.total.itens = this.itens.length;
    },

    onSelect(item) {
      this.itemSelecionado.value = item.value;
      this.itemSelecionado.text = item.text;
      this.item.PRODUTO = item.value;
      this.$refs.pedido_item_quantidade.$el.focus();
      this.$refs.pedido_item_quantidade.$el.value = "";
    }
  },
};
</script>
